// Utility functions (global scope)
async function add_item(variantId, quantity, properties = {}) {
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
        })
    });
}

function financial(x) {
    return parseFloat(x) / 100;
}

function boolean(x) {
    return x === 'true';
}

// Store cropper instances by seed
var cropperInstances = {};

// Track which configurators have been initialized to prevent double initialization
var initializedConfigurators = {};

// Initialize product configurator with optional seed for unique IDs
function initProductConfigurator(seed = '') {
    const cropperKey = seed || 'default';
    
    // Prevent double initialization
    if (initializedConfigurators[cropperKey]) {
        console.log('V1 configurator already initialized' + (seed ? ' for seed: ' + seed : ' (default)') + ' - skipping');
        return;
    }
    initializedConfigurators[cropperKey] = true;
    const suffix = seed ? '-' + seed : '';
    
    // Helper to get element by ID with seed
    function getEl(id) {
        return document.getElementById(id + suffix);
    }
    
    // ========== EARLY EXIT CHECK FOR V1 ELEMENTS ==========
    // Check if this configurator's elements exist before proceeding
    const heightCheck = getEl('customHeight');
    const widthCheck = getEl('customWidth');
    const imageCheck = getEl('cropperImage');
    
    // If none of the required elements exist, exit early
    if (!heightCheck && !widthCheck && !imageCheck) {
        if (seed) {
            console.log('V1 configurator elements not found for seed: ' + seed + ' - skipping initialization');
        }
        return;
    }
    
    if (seed) {
        console.log('V1 configurator elements detected for seed: ' + seed + ' - initializing');
    } else {
        console.log('V1 configurator elements detected (default) - initializing');
    }

    function paperTypeAbTest() {
        const v2Block = document.querySelector('.paper-type-selector-v2-block');
        if (v2Block) {
            const computedStyle = window.getComputedStyle(v2Block);
            if (computedStyle.display !== 'none') {
                const v2Sticky = document.getElementById('sticky-paper-v2');
                if (v2Sticky) return v2Sticky.checked;
            }
        }
        const stickyPaper = getEl('sticky-paper');
        return stickyPaper ? stickyPaper.checked : false;
    }

    const widthInput = getEl('customWidth');
    const heightInput = getEl('customHeight');
    const configuratorBlock = document.querySelector('.configurator-block');
    
    // Check if configurator elements exist
    if (!widthInput || !heightInput || !configuratorBlock) {
        console.log('Configurator not found' + (seed ? ' for seed: ' + seed : ''));
        return;
    }

    const basePrice = financial(configuratorBlock.dataset.basePrice);
    const compareAtPrice = financial(configuratorBlock.dataset.compareAtPrice);
    const hasDiscount = boolean(configuratorBlock.dataset.hasDiscount);
    const productTitle = configuratorBlock.dataset.productTitle;

    const priceDisplay = document.querySelectorAll('.calculatedPrice');

    // Get cropper instance for this seed
    function getCropper() {
        return cropperInstances[cropperKey];
    }

    function setCropper(instance) {
        cropperInstances[cropperKey] = instance;
    }

    function updatePrice() {
        const cropper = getCropper();
        if (!cropper) return;
    const baseWidth = parseFloat(widthInput.value);
    const baseHeight = parseFloat(heightInput.value);
    const width = baseWidth;
    const height = baseHeight;

    var currentBasePrice = basePrice;
    if (paperTypeAbTest()) {
        currentBasePrice += 10;
    }

        if (!isNaN(width) && !isNaN(height)) {
            cropper.setAspectRatio(width / height);

            if (width > height) {
                var new_height = cropper.getContainerData().width * (height / width);
                cropper.setCropBoxData({
                    left: 0,
                    top: (cropper.getContainerData().height / 2) - (new_height / 2),
                    width: cropper.getContainerData().width,
                    height: new_height
                });
            } else {
                var new_width = cropper.getContainerData().height * (width / height);
                cropper.setCropBoxData({
                    left: (cropper.getContainerData().width / 2) - (new_width / 2),
                    top: 0,
                    width: new_width,
                    height: cropper.getContainerData().height
                });
            }

            const totalArea = (baseWidth / 100) * (baseHeight / 100);
            const totalPrice = currentBasePrice * totalArea;

            var originalPrice = totalPrice;
            if (hasDiscount) {
                var originalPrice = compareAtPrice;
                if (paperTypeAbTest()) {
                    originalPrice += 10;
                }
                originalPrice *= totalArea;
            }

            priceDisplay.forEach(function (element) {
                if (hasDiscount) {
                    element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
                } else {
                    element.textContent = totalPrice.toFixed(2) + '€';
                }
            });

            const scalapay_text_amount = getEl('scalapay_text_amount');

            if (scalapay_text_amount) {
                if (hasDiscount) {
                    var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
                    scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
                } else {
                    scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
                }
            }

            var top_width_bar = getEl('top_width_bar');
            var top_height_bar = getEl('right_height_bar');

            if (top_width_bar && top_height_bar) {
                top_width_bar.innerHTML = width + 'cm';
                top_height_bar.innerHTML = `<div id="returned_height_bar_number${suffix}">${height}cm</div>`;
                top_width_bar.style.width = cropper.getCropBoxData().width + 'px';
                top_height_bar.style.height = cropper.getCropBoxData().height + 'px';

                top_width_bar.style.marginLeft = cropper.getCropBoxData().left + 'px';
                top_height_bar.style.marginTop = cropper.getCropBoxData().top + 'px';

                var returned_height_bar_number = getEl('returned_height_bar_number');
                if (returned_height_bar_number) {
                    //margin top 
                    returned_height_bar_number.style.marginTop = (cropper.getCropBoxData().height / 2) - (returned_height_bar_number.offsetHeight / 2) + 'px';
                }
            }

            // Calculate number of rolls and price per roll
            const rollWidthCm = 50; // Standard roll width of 50 cm
            const numberOfRolls = Math.ceil(baseWidth / rollWidthCm); // Round up to ensure enough rolls
            const pricePerRoll = totalPrice / numberOfRolls;

            // Update the roll delivery info
            const numberOfRollsEl = getEl('numberOfRolls');
            const pricePerRollEl = getEl('pricePerRoll');
            if (numberOfRollsEl) numberOfRollsEl.textContent = numberOfRolls;
            if (pricePerRollEl) pricePerRollEl.textContent = pricePerRoll.toFixed(2);
        }
    }

    // Nouvelle fonction pour mettre à jour seulement le prix (sans repositionner le crop)
    function updatePriceOnly() {
        const baseWidth = parseFloat(widthInput.value);
        const baseHeight = parseFloat(heightInput.value);

        var currentBasePrice = basePrice;
        if (paperTypeAbTest()) {
            currentBasePrice += 10;
        }

        if (!isNaN(baseWidth) && !isNaN(baseHeight)) {
            const totalArea = (baseWidth / 100) * (baseHeight / 100);
            const totalPrice = currentBasePrice * totalArea;

            var originalPrice = totalPrice;
            if (hasDiscount) {
                var originalPrice = compareAtPrice;
                if (paperTypeAbTest()) {
                    originalPrice += 10;
                }
                originalPrice *= totalArea;
            }

            priceDisplay.forEach(function (element) {
                if (hasDiscount) {
                    element.innerHTML = '<span style="text-decoration: line-through;font-weight:normal;">' + originalPrice.toFixed(2) + '€</span> <span>' + totalPrice.toFixed(2) + '€';
                } else {
                    element.textContent = totalPrice.toFixed(2) + '€';
                }
            });

            const scalapay_text_amount = getEl('scalapay_text_amount');

            if (scalapay_text_amount) {
                if (hasDiscount) {
                    var difference = originalPrice.toFixed(2) - totalPrice.toFixed(2);
                    scalapay_text_amount.innerHTML = '<b>DERNIÈRE CHANCE : Économisez ' + difference.toFixed(2) + '€ en passant commande aujourd\'hui !</b>';
                } else {
                    scalapay_text_amount.innerHTML = 'ou 3 fois <b>' + (totalPrice / 3).toFixed(2) + '€</b> sans frais avec ';
                }
            }

            // Calculate number of rolls and price per roll
            const rollWidthCm = 50; // Standard roll width of 50 cm
            const numberOfRolls = Math.ceil(baseWidth / rollWidthCm); // Round up to ensure enough rolls
            const pricePerRoll = totalPrice / numberOfRolls;

            // Update the roll delivery info
            const numberOfRollsEl = getEl('numberOfRolls');
            const pricePerRollEl = getEl('pricePerRoll');
            if (numberOfRollsEl) numberOfRollsEl.textContent = numberOfRolls;
            if (pricePerRollEl) pricePerRollEl.textContent = pricePerRoll.toFixed(2);
        }
    }

    var image = getEl('cropperImage');
    if (!image) {
        console.log('Cropper image not found' + (seed ? ' for seed: ' + seed : ''));
        return;
    }

    function load_cropper() {
        // Check if Cropper.js is loaded
        if (typeof Cropper === 'undefined') {
            console.error('Cropper.js library not loaded' + (seed ? ' for seed: ' + seed : ''));
            return;
        }

        // Variable to hold the cropper instance for use in callbacks
        let cropperRef = null;

        const cropperInstance = new Cropper(image, {
            autoCropArea: 1,
            viewMode: 1,
            movable: false,
            zoomable: false,
            zoomOnTouch: false,
            zoomOnWheel: false,
            restore: false,
            wheelZoomRatio: 0,
            rotatable: false,
            scalable: true,
            dragMode: 'move',
            modal: true,
            cropBoxResizable: false,
            cropBoxMovable: true,
            cropmove: function (event) {
                const canvas = document.querySelector('.cropper-canvas');
                if (canvas) canvas.classList.add('copper-canvas-moving');
                
                // Use the stored reference
                if (!cropperRef) return;
                
                // move bars
                var top_width_bar = getEl('top_width_bar');
                var top_height_bar = getEl('right_height_bar');

                if (top_height_bar) {
                    top_height_bar.style.height = cropperRef.getCropBoxData().height + 'px';
                }

                if (top_width_bar) {
                    top_width_bar.style.marginLeft = cropperRef.getCropBoxData().left + 'px';
                }
                if (top_height_bar) {
                    top_height_bar.style.marginTop = cropperRef.getCropBoxData().top + 'px';
                }
            },
            cropend: function (event) {
                const canvas = document.querySelector('.cropper-canvas');
                if (canvas) canvas.classList.remove('copper-canvas-moving');
            },
            ready: function () {
                // Store the reference for callbacks
                cropperRef = cropperInstance;
                // Store in global registry
                setCropper(cropperInstance);
                updatePrice();
                const cropperButton = getEl('cropperButton');
                if (cropperButton) cropperButton.disabled = false;
            }
        });

        // Store reference immediately for safety
        cropperRef = cropperInstance;
        setCropper(cropperInstance);
    }

    var show_resize_warning = () => {
        var cropping_table_resize_warning_box = document.querySelector('.cropping_table_resize_warning_box');

        if (cropping_table_resize_warning_box) {
            cropping_table_resize_warning_box.classList.add('show');

            setTimeout(function () {
                cropping_table_resize_warning_box.classList.add('show-bump');
            }, 500);

            setTimeout(function () {
                cropping_table_resize_warning_box.classList.remove('show', 'show-bump');
            }, 5000);
        }
    };

    widthInput.addEventListener('input', () => {
        updatePrice();
        show_resize_warning();
    });
    heightInput.addEventListener('input', () => {
        updatePrice();
        show_resize_warning();
    });

    document.querySelectorAll('.paper-type').forEach(function (element) {
        element.addEventListener('change', updatePriceOnly);
    });

    // Wait for Cropper.js to be available
    function waitForCropper(callback, maxAttempts = 50) {
        let attempts = 0;
        
        const checkInterval = setInterval(function() {
            attempts++;
            
            if (typeof Cropper !== 'undefined') {
                clearInterval(checkInterval);
                callback();
            } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.error('Cropper.js failed to load after ' + maxAttempts + ' attempts' + (seed ? ' for seed: ' + seed : ''));
            }
        }, 100);
    }

    // Initialize on DOM ready or immediately if already loaded
    function initConfigurator() {
        let date = new Date();
        date.setDate(date.getDate() + 2); // Ajoute 2 jours à la date actuelle

        let year = date.getFullYear();
        let month = ("0" + (date.getMonth() + 1)).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);

        document.querySelectorAll(".new_day").forEach(function (element) {
            element.textContent = day;
        });
        document.querySelectorAll(".new_month").forEach(function (element) {
            element.textContent = getMonthName(month);
        });

        function getMonthName(monthNumber) {
            const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
            return months[parseInt(monthNumber) - 1];
        }

        // Setup reverse mode listener - will be initialized after cropper loads
        function setupReverseModeListener() {
            const reverseMode = getEl('reverseMode');
            if (reverseMode) {
                reverseMode.addEventListener('change', function () {
                    const cropper = getCropper();
                    if (!cropper) {
                        console.warn('Cropper not yet initialized');
                        return;
                    }
                    if (this.checked) {
                        cropper.scaleX(-1);
                    } else {
                        cropper.scaleX(1);
                    }
                });
            }
        }

        function initInfoPopup(iconId, popupId) {
            const icon = getEl(iconId);
            const popup = getEl(popupId);
            
            if (!icon || !popup) return;
            
            const closeBtn = popup.querySelector('.info-popup-close');

            // Detect whether user is on a smaller screen (mobile/tablet)
            let isMobile = window.matchMedia("(max-width: 768px)").matches;

            if (!isMobile) {
                // On larger screens: show the popup on hover, hide it on mouseout.
                icon.addEventListener('mouseenter', () => {
                    popup.style.display = 'block';
                });
                icon.addEventListener('mouseleave', () => {
                    popup.style.display = 'none';
                });
                popup.addEventListener('mouseenter', () => {
                    popup.style.display = 'block';
                });
                popup.addEventListener('mouseleave', () => {
                    popup.style.display = 'none';
                });
            }

            // On mobile (or fallback), use click to toggle show/hide
            icon.addEventListener('click', (e) => {
                // Prevent immediate "mouseleave" from closing it
                e.stopPropagation();
                if (popup.style.display === 'block') {
                    popup.style.display = 'none';
                } else {
                    popup.style.display = 'block';
                }
            });

            // Close button for mobile
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    popup.style.display = 'none';
                });
            }

            // (Optional) if you want to close when clicking anywhere else on mobile:
            document.body.addEventListener('click', (ev) => {
                if (isMobile && popup.style.display === 'block') {
                    // If user clicked outside the popup & icon
                    if (!popup.contains(ev.target) && ev.target !== icon) {
                        popup.style.display = 'none';
                    }
                }
            }, true);
        }

        // Setup add to cart button listener
        function setupAddToCartListener() {
            const cropperButton = getEl('cropperButton');
            if (!cropperButton) {
                console.warn('Cropper button not found' + (seed ? ' for seed: ' + seed : ''));
                return;
            }
            
            cropperButton.addEventListener('click', function () {
                var error_box = getEl('add_to_cart_error_box');

                if (error_box) {
                    error_box.innerHTML = '';
                }
                
                if (widthInput.value == '' || heightInput.value == '') {
                    if (error_box) {
                        error_box.style.display = 'block';
                        error_box.innerHTML = 'Veuillez d\'abord renseigner les dimensions de votre papier peint.';
                    }
                    return;
                }

                if (widthInput.value < 100 || widthInput.value > 6000) {
                    if (error_box) {
                        error_box.style.display = 'block';
                        error_box.innerHTML = 'La largeur de votre papier peint doit être comprise entre 100cm et 6 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
                    }
                    return;
                }

                if (heightInput.value < 100 || heightInput.value > 4000) {
                    if (error_box) {
                        error_box.style.display = 'block';
                        error_box.innerHTML = 'La hauteur de votre papier peint doit être comprise entre 100cm et 4 mètres.<br/>Si vous souhaitez un plus grand format veuillez nous contacter à <a href="mailto:info@lepapierpeint.fr" style="color:#2e2e2e;">info@lepapierpeint.fr</a>';
                    }
                    return;
                }

                if (typeof _learnq !== 'undefined' && typeof item !== 'undefined') {
                    _learnq.push(['track', 'Added to Cart', item]);
                }

                // Get crop coordinates and prepare parameters for localStorage
                const cropper = getCropper();
                if (!cropper) {
                    console.error('Cropper not initialized');
                    return;
                }
                
                const crop_box = cropper.getData();

                const configuratorBlock = document.querySelector('.configurator-block');
                if (!configuratorBlock) {
                    console.error('Configurator block not found');
                    return;
                }
                const product_id = configuratorBlock.dataset.productId;
                
                const reverseMode = getEl('reverseMode');
                const reverseModeChecked = reverseMode ? reverseMode.checked : false;

                // Prepare all parameters for localStorage (without large image data)
                const orderData = {
                    origin_url: image.src,
                    product_id: product_id,
                    width: widthInput.value,
                    height: heightInput.value,
                    sticky_paper: paperTypeAbTest(),
                    reverse_mode: reverseModeChecked,
                    crop_box: {
                        x: crop_box.x,
                        y: crop_box.y,
                        width: crop_box.width,
                        height: crop_box.height
                    },
                    custom_metafields: {
                        'Dimensions': heightInput.value + ' x ' + widthInput.value + ' cm' + (reverseModeChecked ? ' (miroir)' : ''),
                        'Type de papier': paperTypeAbTest() ? 'Autocollant' : 'Premium',
                        '_product_title': productTitle
                    }
                };

                // Store in localStorage
                localStorage.setItem('lepapierpeint_order_data', JSON.stringify(orderData));

                // Redirect immediately to loading page
                window.location.href = '/pages/chargement-de-votre-papier-peint';
            });
        }

        initInfoPopup('infoIcon1', 'infoPopup1');
        initInfoPopup('infoIcon2', 'infoPopup2');

        // Wait for Cropper.js before initializing cropper
        waitForCropper(function() {
            load_cropper();
            // Setup reverse mode listener after cropper is initialized
            setupReverseModeListener();
            // Setup add to cart button listener after cropper is initialized
            setupAddToCartListener();
        });
    }

    // Run initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initConfigurator);
    } else {
        initConfigurator();
    }

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
        let newWidth = window.innerWidth;

        if (lastWidth !== newWidth) {
            updatePriceOnly(); // Use updatePriceOnly to avoid resetting crop box position on mobile scroll
        }
    });

    var _learnq = _learnq || [];
}

// Initialize default configurator (no seed) on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initProductConfigurator();
    });
} else {
    initProductConfigurator();
}